export default {
  SITE_USER: 1,
  SITE_ADMIN: 2,
  SUPER_USER: 3,
  SUPER_ADMIN: 4,
  DISPLAY_USER: 5,
  CALL_VIEWER: 6,
  EMPTY: 123456
};
